import React, { Component } from 'react';
import "./404.css";

class InstallError extends Component {
  componentDidMount() {
    const script = document.createElement("script");
    script.src = "https://www.centro.rocks/js/navigation.js";
    document.head.appendChild(script);
    const install = document.createElement("script");
    install.src = "https://www.centro.rocks/js/install.js";
    document.head.appendChild(install);
  }

  render() {
    return <div>
      <div className="centro-404-container">
        <div className="center">
          <h1>Installation Error</h1>
          <img alt="empty state" src="/assets/images/illustrations/empty-state-assistant.svg" />
          <h2>Oops! An unexpected error occured during authorization.</h2>
          <h3>Please contact Centro Support <a href="mailto:support@centro.rocks">support@centro.rocks</a> for help troubleshooting.</h3>
        </div>
      </div>
    </div>
  };
}

export default InstallError;